var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1001 12C2.1001 6.53236 6.53248 2.09998 12.0001 2.09998C17.4677 2.09998 21.9001 6.53236 21.9001 12C21.9001 17.4676 17.4677 21.9 12.0001 21.9C6.53248 21.9 2.1001 17.4676 2.1001 12ZM12.0001 3.89998C16.4736 3.89998 20.1001 7.52647 20.1001 12C20.1001 13.9125 19.4373 15.6702 18.3288 17.0559L6.94418 5.67127C8.32988 4.5628 10.0876 3.89998 12.0001 3.89998ZM3.9001 12C3.9001 16.4735 7.52659 20.1 12.0001 20.1C13.9126 20.1 15.6703 19.4372 17.056 18.3287L5.67139 6.94406C4.56292 8.32976 3.9001 10.0875 3.9001 12Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockOutline);
export default __webpack_public_path__ + "static/media/block_outline.516c0302199d256508ca2a6b53ac8ec4.svg";
export { ForwardRef as ReactComponent };